import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=5d083f40&"
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput,QBtn,QSpinnerHourglass} from 'quasar'
component.options.components = Object.assign({QInput,QBtn,QSpinnerHourglass}, component.options.components || {})
